import { CoreService } from "./../../services/coreService";
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ElementRef,
  ChangeDetectorRef
} from "@angular/core";
import {
  distinctUntilChanged,
  debounceTime,
  takeWhile,
  tap,
  switchMap,
  map,
  catchError
} from "rxjs/operators";
import { timer, Subject } from "rxjs";
import { UntypedFormGroup, UntypedFormBuilder, ReactiveFormsModule } from "@angular/forms";
import { Icons, IconCss, UserGroups } from "../../../assets/config/models";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { CommonModule } from "@angular/common";

@Component({
    selector: "parking-place-live-parking",
    templateUrl: "./parking-place-live-parking.component.html",
    styleUrls: ["./parking-place-live-parking.component.scss"],
    standalone: true,
    imports: [NgxDatatableModule, ReactiveFormsModule, CommonModule]
})
export class ParkingPlaceLiveParkingComponent
  implements OnInit, OnDestroy, OnChanges {
  @Input()
  id;
  @Input()
  group;
  @ViewChild("mydatatable", {static: true})
  groupTypes = UserGroups;
  mydatatable: any;
  loading = false;
  sortIcons = Icons;
  sortColumns = [];
  sorts = { prop: "", dir: "" };
  form: UntypedFormGroup;
  total_number = 0;
  isLoading = false;
  rows = [];
  icons = IconCss;
  iconsCss = {
    pagerLeftArrow: this.icons.left,
    pagerRightArrow: this.icons.right,
    pagerPrevious: this.icons.previous,
    pagerNext: this.icons.next
  };
  live$ = new Subject<{
    previousValue: any;
    currentValue: any;
    formChange?: boolean;
  }>();
  formChanges$;

  readonly headerHeight = 80;
  readonly rowHeight = 70;
  pageLimit = 5;

  constructor(
    private coreService: CoreService,
    private el: ElementRef,
    private cd: ChangeDetectorRef,
    private builder: UntypedFormBuilder
  ) {
    this.form = this.builder.group({
      name: [""],
      vehicle_number: [""]
    });
    this.pageLimit = 10;
    // this.live$
    //   .pipe(
    //     takeWhile(() => this.id != null),
    //     tap(val => {
    //       if (
    //         val.previousValue != val.currentValue &&
    //         this.mydatatable != null
    //       ) {
    //         // this.mydatatable.element.childNodes[0].childNodes[2].scrollTop = 0;
    //         this.total_number = 0;
    //         this.form.reset();
    //         this.setSort();
    //         this.sorts = { prop: "", dir: "" };
    //       } else if (val.formChange) {
    //         // this.mydatatable.element.childNodes[0].childNodes[2].scrollTop = 0;
    //         this.total_number = 0;
    //         this.isLoading = true;
    //       }
    //     }),
    //     switchMap(() => timer(0, 1000 * 10)),
    //     tap(() => (this.isLoading = true)),
    //     switchMap(val => {
    //       return this.coreService.GetParkingPlaceLiveParking(
    //         {
    //           offset: 0,
    //           limit:
    //             this.total_number != 0
    //               ? this.rows.length < this.pageLimit
    //                 ? this.pageLimit
    //                 : this.rows.length
    //               : 10
    //         },
    //         this.form.controls,
    //         this.sorts,
    //         this.id
    //       );
    //     }),
    //     tap(() => (this.isLoading = false)),

    //     catchError(e => {
    //       this.isLoading = false;
    //       return this.coreService.handleObservableError(e);
    //     })
    //   )
    //   .subscribe((response: any) => {
    //     this.rows = response.data;
    //     this.total_number = response.total_list;
    //   });
    this.setSort();
  }

  resetFilters() {
    this.form.reset();
    this.sorts = { prop: "", dir: "" };
    this.setSort();
  }

  getIcon(prop) {
    return this.sortColumns.find(element => element.prop == prop).icon;
  }

  setSort() {
    this.sortColumns = [];
    for (let key of Object.keys(this.form.value)) {
      this.sortColumns.push({
        prop: key,
        icon: this.sortIcons.none
      });
    }
    this.sortColumns.push({
      prop: "in_time",
      icon: this.sortIcons.none
    });
  }

  onSort(event) {
    console.log("event", event);
    this.sorts = event.sorts[0];
    this.setSort();
    let icon;
    switch (event.sorts[0].dir) {
      case "asc": {
        icon = this.sortIcons.asc;
        break;
      }
      case "desc": {
        icon = this.sortIcons.desc;
        break;
      }
      default: {
        icon = this.sortIcons.none;
        break;
      }
    }
    this.sortColumns.find(
      element => element.prop == event.sorts[0].prop
    ).icon = icon;
    this.live$.next({ previousValue: this.id, currentValue: this.id });
  }

  onScroll(event) {
    // total height of all rows in the viewport
    setTimeout(() => {
      // total height of all rows in the viewport

      if (event.path != null && this.rows.length != this.total_number) {
        const offsetY = event.path[0].scrollTop;
        const viewHeight = event.path[0].scrollHeight - 20;
        const clientHeight = event.path[0].clientHeight;
        console.log(
          `Offset: ${offsetY}, viewHeight: ${viewHeight}, clientHeight: ${clientHeight}`
        );
        // check if we scrolled to the end of the viewport
        if (!this.isLoading && offsetY + clientHeight >= viewHeight) {
          console.log("I should be loading");
          this.loadPage(this.pageLimit);
        }
      }
    }, 0);
  }

  async loadPage(limit: number) {
    // set the loading flag, which serves two purposes:
    // 1) it prevents the same page from being loaded twice
    // 2) it enables display of the loading indicator
    if (this.id != null) {
      this.isLoading = true;
      try {
        // let data: any = await this.coreService
        //   .GetParkingPlaceLiveParking(
        //     {
        //       offset: this.rows.length,
        //       limit: limit
        //     },
        //     this.sorts,
        //     this.form.value,
        //     this.id
        //   )
        //   .toPromise();
        // let temp = this.rows;
        // temp.push(...data.data);
        // this.rows = [...temp];
        // this.total_number = data.total_list;
      } catch (error) {
        console.log(error);
      } finally {
        this.cd.markForCheck();
        //this.mydatatable.update();
        this.isLoading = false;
      }
    }
  }

  async ngOnInit() {
    this.formChanges$ = this.form.valueChanges
      .pipe(
        debounceTime(1000),
        distinctUntilChanged()
      )
      .subscribe(form => {
        this.live$.next({
          previousValue: this.id,
          currentValue: this.id,
          formChange: true
        });
      });
  }

  ngOnDestroy(): void {
    this.live$.unsubscribe();
    this.formChanges$.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.id.currentValue != null) {
      this.live$.next(changes.id);
    }
  }
}
